import { TmrBaseResource } from 'stylewhere/api'

export class Zones extends TmrBaseResource {
  static endpoint = 'api/v1/zones' // profile
}
